var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm._l(_vm.content, function(item) {
          return _c(
            "div",
            { key: item.id, staticClass: "col-sm-6" },
            [_c("Item", _vm._b({}, "Item", item, false))],
            1
          )
        }),
        _vm._v(" "),
        _vm.total > _vm.pageSize
          ? _c("div", { staticClass: "col-12 pagination mt-3" }, [
              _c("p", { staticClass: "pagination-summary" }, [
                _vm._v(
                  "\n\t\t\t\tTotal de Inmuebles: " +
                    _vm._s(_vm.total) +
                    ", mostrando del\n\t\t\t\t" +
                    _vm._s((_vm.pageNumber - 1) * _vm.pageSize + 1) +
                    " al\n\t\t\t\t" +
                    _vm._s(
                      (_vm.pageNumber - 1) * _vm.pageSize + _vm.content.length
                    ) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-list" },
                [
                  _vm.pageNumber > 1
                    ? _c(
                        "router-link",
                        {
                          staticClass: "pagination-item pagination-item_prev",
                          attrs: {
                            to: {
                              query: Object.assign({}, _vm.$route.query, {
                                transactionType: _vm.transactionType,
                                pageNumber: _vm.pageNumber - 1
                              })
                            }
                          }
                        },
                        [_vm._v("\n\t\t\t\t\tAnterior\n\t\t\t\t")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.pagination, function(p, n) {
                    return [
                      p
                        ? _c(
                            "router-link",
                            {
                              key: "p_" + n,
                              staticClass: "pagination-item",
                              class: {
                                "pagination-item_active": p == _vm.pageNumber
                              },
                              attrs: {
                                to: {
                                  query: Object.assign({}, _vm.$route.query, {
                                    transactionType: _vm.transactionType,
                                    pageNumber: p
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" + _vm._s(p) + "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              key: "p_" + n,
                              staticClass:
                                "pagination-item pagination-item_dots"
                            },
                            [_vm._v("...")]
                          )
                    ]
                  }),
                  _vm._v(" "),
                  _vm.pageNumber < _vm.total
                    ? _c(
                        "router-link",
                        {
                          staticClass: "pagination-item pagination-item_next",
                          attrs: {
                            to: {
                              query: Object.assign({}, _vm.$route.query, {
                                transactionType: _vm.transactionType,
                                pageNumber: _vm.pageNumber + 1
                              })
                            }
                          }
                        },
                        [_vm._v("\n\t\t\t\t\tSiguiente\n\t\t\t\t")]
                      )
                    : _vm._e()
                ],
                2
              )
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }